import { styled } from '@mui/material/styles';
import StatusChip, { STATUS_PALETTE } from '@components/StatusChip';

// Shared status pill: maps a status value to a tone + i18n label. Used by both the campaign
// lifecycle chip and the per-post outcome chip.
const Wrapper = styled('div')({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
});

const StatusBadge = ({ status, toneByStatus, labelKeyByStatus, t }) => {
    const labelKey = labelKeyByStatus[status];
    if (!labelKey) return null;

    const tone = STATUS_PALETTE[toneByStatus[status] ?? 'neutral'];
    return (
        <Wrapper>
            <StatusChip bg={tone.bg} fg={tone.fg} label={t(labelKey)} />
        </Wrapper>
    );
};

export default StatusBadge;
